const API_BASE_URL = "https://robocor-server.vercel.app";

export default API_BASE_URL;
